module.exports = __webpack_public_path__ + "img/4.c34a25e3.png";